import React, { useEffect, useState } from 'react';
import "./NotificationsItem.scss"

import PostService from '../../../API/PostService';
import { useFetching } from '../../../hooks/useFetching';
import { setCountAction } from '../../../store/notificationsReducer';
import { useDispatch } from 'react-redux';

import { getNotificationDateString } from '../../../helpers/datetime';

import { Link } from 'react-router-dom';

const NotificationsItem = ({ element }) => {
	const dispatch = useDispatch()
	const [ viewed, setViewed ] = useState(element.read !== '0');

	const onMouseEnterHandler = () => {
		if(viewed) return;
		fetchMarkNotificationAsViewed(element.id);
	}

	const [fetchMarkNotificationAsViewed] = useFetching(async (notificationId) => {
		const response = await PostService.markNotificationAsViewed(notificationId)
		if (response.data.success) {
			setViewed(true)
			fetchUserUnreadNotificationsCount();
		}
	})

	const [fetchUserUnreadNotificationsCount] = useFetching(async () => {
		const response = await PostService.getUserUnreadNotificationsCount()
		if (response.data.success && response.data.result !== false) {
			dispatch(setCountAction(Number(response.data.result)))
		}
	})

	return (
			<Link
			to={element?.record?.id ? '/' + element.record.id + '/' : ''}
			className='notifications-item__link'>
				<div className={"notifications-item" + (!viewed ? " not-viewed" : "")} onMouseEnter={onMouseEnterHandler}>
					<div className="notifications-item__date">{getNotificationDateString(element.datetime_timestamp * 1000)}</div>
					<div className="notifications-item__title">{element.type}</div>
					{element.record &&
					<>
						<div className="notifications-item__client">
							{element.record.name}&nbsp;{element.record.last_name}
							{
								element.record.age &&
								<>, {element.record.age}</>
							}
						</div>
						<div className="notifications-item__details">
							{element.record.date_formated_3},&nbsp;{element.record.time_formated}-{element.record.time_end_formated}
							<br></br>
							{element.record.clinic.address},&nbsp;{element.record.clinic.description}
						</div>
					</>
					}
				</div>
			</Link>
	);
};

export default NotificationsItem;
